import styled from 'styled-components'

export const LicenseCardNotificationWrapper = styled.div`
  margin-bottom: 2.25rem;
`
